document.addEventListener("DOMContentLoaded", function () {
  const generateBtn = document.getElementById("passageGenerateBtn");
  const downloadBtn = document.getElementById("passageDownloadBtn");
  const paperSizeSelect = document.getElementById("passagePaperSize");
  const customSizeDiv = document.getElementById("passageCustomSize");
  let isExportingPassagePDF = false;
  if (!generateBtn || !downloadBtn || !paperSizeSelect || !customSizeDiv) {
    return;
  }
  paperSizeSelect.addEventListener("change", function () {
    customSizeDiv.style.display = this.value === "custom" ? "block" : "none";
  });
  if (!generateBtn.dataset.listenerAttached) {
    generateBtn.addEventListener("click", drawPassageSheet);
    generateBtn.dataset.listenerAttached = "true";
  }
  if (!downloadBtn.dataset.listenerAttached) {
    downloadBtn.addEventListener("click", exportPassagePDF);
    downloadBtn.dataset.listenerAttached = "true";
  }
  function drawPassageSheet() {
    const canvas = document.getElementById("passageCanvas");
    const ctx = canvas.getContext("2d");
    const mmToPx = 3.78;
    const dpiScale = 2.5;
    canvas.style.display = "block";
    let paperWidthMM = 210;
    let paperHeightMM = 297;
    const selectedSize = document.getElementById("passagePaperSize").value;
    if (selectedSize === "A5") {
      paperWidthMM = 148;
      paperHeightMM = 210;
    } else if (selectedSize === "A6") {
      paperWidthMM = 105;
      paperHeightMM = 148;
    } else if (selectedSize === "custom") {
      paperWidthMM = parseFloat(document.getElementById("passageCustomWidth").value);
      paperHeightMM = parseFloat(document.getElementById("passageCustomHeight").value);
    }
    const orientation = document.getElementById("passageOrientation").value;
    if (orientation === "landscape") {
      [paperWidthMM, paperHeightMM] = [paperHeightMM, paperWidthMM];
    }
    const canvasWidth = paperWidthMM * mmToPx;
    const canvasHeight = paperHeightMM * mmToPx;
    canvas.width = canvasWidth * dpiScale;
    canvas.height = canvasHeight * dpiScale;
    canvas.style.width = canvasWidth + "px";
    canvas.style.height = canvasHeight + "px";
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpiScale, dpiScale);
    const marginTopMM = parseFloat(document.getElementById("passageMarginTop").value) || 10;
    const marginBottomMM = parseFloat(document.getElementById("passageMarginBottom").value) || 10;
    const marginLeftMM = parseFloat(document.getElementById("passageMarginLeft").value) || 10;
    const marginRightMM = parseFloat(document.getElementById("passageMarginRight").value) || 10;
    const marginTopPx = marginTopMM * mmToPx;
    const marginBottomPx = marginBottomMM * mmToPx;
    const marginLeftPx = marginLeftMM * mmToPx;
    const marginRightPx = marginRightMM * mmToPx;
    const usableWidth = canvasWidth - marginLeftPx - marginRightPx;
    const usableHeight = canvasHeight - marginTopPx - marginBottomPx;
    const spacingMM = parseFloat(document.getElementById("passageXHeight").value) || 5;
    const slantAngle = parseFloat(document.getElementById("passageSlantAngle").value) || 55;
    const radians = (90 - slantAngle) * Math.PI / 180;
    const spacingPx = spacingMM * mmToPx;
    const letterSpacing = parseFloat(document.getElementById("passageLetterSpacing").value) || 0;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = "#888";
    ctx.lineWidth = 0.3;
    ctx.beginPath();
    ctx.rect(marginLeftPx, marginTopPx, usableWidth, usableHeight);
    ctx.stroke();
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.font = `${11 * dpiScale}px Century Gothic`;
    ctx.fillStyle = "#000";
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillText(`x-Height ${spacingMM}mm / Slant ${slantAngle} / Letter Spacing ${letterSpacing}px`, canvas.width / 2, marginTopPx * dpiScale / 2);
    ctx.textBaseline = "bottom";
    ctx.fillText("Handwrite House© All Rights Reserved", canvas.width / 2, canvas.height - marginBottomPx * dpiScale / 2);
    ctx.restore();
    for (let y = marginTopPx; y <= canvasHeight - marginBottomPx; y += spacingPx) {
      ctx.beginPath();
      ctx.moveTo(marginLeftPx, y);
      ctx.lineTo(canvasWidth - marginRightPx, y);
      ctx.stroke();
    }
    const fullHeight = usableHeight;
    const dx = -fullHeight * Math.tan(radians);
    const slantSpacingMM = 20;
    const slantSpacingPx = slantSpacingMM * mmToPx;
    const horizontalSpacing = slantSpacingPx;
    const overshoot = usableWidth + Math.abs(dx);
    const startX = marginLeftPx - overshoot;
    const endX = canvasWidth - marginRightPx + overshoot;
    for (let x = startX; x <= endX; x += horizontalSpacing) {
      const x1 = x;
      const y1 = marginTopPx;
      const x2 = x + dx;
      const y2 = canvasHeight - marginBottomPx;
      const clipped = clipToBox(x1, y1, x2, y2, marginLeftPx, marginTopPx, canvasWidth - marginRightPx, canvasHeight - marginBottomPx);
      if (clipped) {
        ctx.beginPath();
        ctx.moveTo(clipped.x1, clipped.y1);
        ctx.lineTo(clipped.x2, clipped.y2);
        ctx.stroke();
      }
    }
    const passageText = document.getElementById("passageText").value.trim();

    const physicalLetterSpacing = letterSpacing * dpiScale;
    if (passageText) {
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      let testSize = 100;
      const selectedFont = document.getElementById("passageFont").value;
      ctx.font = `${testSize}px '${selectedFont}', cursive`;
      const metrics = ctx.measureText("x");
      const actualXHeight = metrics.actualBoundingBoxAscent;
      const scaleFactor = spacingPx / actualXHeight;
      const fontSizePx = testSize * scaleFactor;
      ctx.font = `${fontSizePx * dpiScale}px '${selectedFont}', cursive`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      const lines = passageText.split("\n");


      const firstLine = lines[0] || "";
      let firstLineWidthPx = 0;
      if (firstLine) {
        const chars = firstLine.split('');
        const charWidths = chars.map(char => ctx.measureText(char).width);
        firstLineWidthPx = charWidths.reduce((a, b) => a + b, 0);
        if (chars.length > 1) {
          firstLineWidthPx += (chars.length - 1) * physicalLetterSpacing;
        }
      }
      const firstLineWidthMM = firstLineWidthPx / (mmToPx * dpiScale);
      document.getElementById("passageTextWidthDisplay").textContent =
        `Width of Text in First Line: ${firstLineWidthMM.toFixed(2)} mm`;

      const lineSpacingFactor = parseInt(document.getElementById("passageLineSpacingFactor").value) || 5;
      const verticalAlign = document.getElementById("passageVerticalAlign").value;
      const lineCount = lines.length;
      const totalTextHeight = lineCount * spacingPx * lineSpacingFactor;
      const totalGuideLines = Math.floor(usableHeight / spacingPx);
      const passageLines = lines.length;
      const passageHeightInLines = (passageLines - 1) * lineSpacingFactor;
      let startLineIndex;
      if (verticalAlign === "top") {
        startLineIndex = 2;
      } else if (verticalAlign === "center") {
        startLineIndex = Math.floor((totalGuideLines - passageHeightInLines) / 2) - 1;
      } else if (verticalAlign === "bottom") {
        startLineIndex = (totalGuideLines - passageHeightInLines) - 5;
      }
      const startY = marginTopPx + startLineIndex * spacingPx;
      const baselineOffset = spacingPx * 1.5;
      const adjustedStartY = startY + baselineOffset;
      const horizontalAlign = document.getElementById("passageHorizontalAlign").value;

      // Store line gap information for display
      const lineGaps = [];
      const physicalMarginLeft = marginLeftPx * dpiScale;
      const physicalMarginRight = marginRightPx * dpiScale;

      lines.forEach((line, i) => {
        const y = adjustedStartY + i * spacingPx * lineSpacingFactor;
        if (y < canvasHeight - marginBottomPx) {
          const physicalY = y * dpiScale;
          const chars = line.split('');
          if (chars.length === 0) {
            lineGaps.push(null);
            return;
          }
          let totalWidth = 0;
          const charWidths = [];
          for (let char of chars) {
            const w = ctx.measureText(char).width;
            charWidths.push(w);
            totalWidth += w;
          }
          if (chars.length > 1) {
            totalWidth += (chars.length - 1) * physicalLetterSpacing;
          }
          let startPhysicalX;
          const physicalCanvasWidth = canvas.width;
          const usablePhysicalWidth = usableWidth * dpiScale;
          if (horizontalAlign === "left") {
            startPhysicalX = physicalMarginLeft;
          } else if (horizontalAlign === "center") {
            startPhysicalX = physicalMarginLeft + ((usablePhysicalWidth - totalWidth) / 2);
          } else if (horizontalAlign === "right") {
            startPhysicalX = physicalCanvasWidth - physicalMarginRight - totalWidth;
          }

          // Calculate gap from left edge of paper to start of text in mm
          const gapMM = startPhysicalX / (mmToPx * dpiScale);
          lineGaps.push({ y: physicalY, gapMM: gapMM });

          let currentX = startPhysicalX;
          for (let j = 0; j < chars.length; j++) {
            ctx.fillText(chars[j], currentX, physicalY);
            currentX += charWidths[j] + physicalLetterSpacing;
          }
        }
      });

      // Display line gaps on the left side outside the margin
      const showLineGaps = document.getElementById("passageShowLineGaps").checked;
      if (showLineGaps) {
        ctx.font = `${7 * dpiScale}px Century Gothic`;
        ctx.fillStyle = "#666";
        ctx.textAlign = "right";
        ctx.textBaseline = "middle";
        lineGaps.forEach((gap, i) => {
          if (gap !== null) {
            const gapText = gap.gapMM.toFixed(1);
            ctx.fillText(gapText, physicalMarginLeft - 10, gap.y);
          }
        });
      }

      ctx.restore();
    }
  }
  function clipToBox(x1, y1, x2, y2, xmin, ymin, xmax, ymax) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    let t0 = 0, t1 = 1;
    const clip = (p, q) => {
      if (p === 0) return q >= 0;
      const r = q / p;
      if (p < 0) {
        if (r > t1) return false;
        if (r > t0) t0 = r;
      } else {
        if (r < t0) return false;
        if (r < t1) t1 = r;
      }
      return true;
    };
    if (
      clip(-dx, x1 - xmin) &&
      clip(dx, xmax - x1) &&
      clip(-dy, y1 - ymin) &&
      clip(dy, ymax - y1)
    ) {
      return {
        x1: x1 + t0 * dx,
        y1: y1 + t0 * dy,
        x2: x1 + t1 * dx,
        y2: y1 + t1 * dy
      };
    }
    return null;
  }
  function exportPassagePDF() {
    if (isExportingPassagePDF) {
      return;
    }
    isExportingPassagePDF = true;
    downloadBtn.disabled = true;

    const mmToPt = 2.83465;
    const mmToPx = 3.78;
    const paperSize = document.getElementById("passagePaperSize").value;
    let widthMM = 210;
    let heightMM = 297;
    if (paperSize === "A5") {
      widthMM = 148;
      heightMM = 210;
    } else if (paperSize === "A6") {
      widthMM = 105;
      heightMM = 148;
    } else if (paperSize === "custom") {
      widthMM = parseFloat(document.getElementById("passageCustomWidth").value);
      heightMM = parseFloat(document.getElementById("passageCustomHeight").value);
    }
    const orientation = document.getElementById("passageOrientation").value;
    const isLandscape = orientation === "landscape";
    const pdfWidthPt = isLandscape ? heightMM * mmToPt : widthMM * mmToPt;
    const pdfHeightPt = isLandscape ? widthMM * mmToPt : heightMM * mmToPt;
    const canvasWidthPx = isLandscape ? heightMM * mmToPx : widthMM * mmToPx;
    const canvasHeightPx = isLandscape ? widthMM * mmToPx : heightMM * mmToPx;
    html2canvas(document.getElementById("passageCanvas"), {
      scale: 5,
      width: canvasWidthPx,
      height: canvasHeightPx,
      useCORS: true
    }).then(canvas => {
      const imgData = canvas.toDataURL("image/jpeg", 1);
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({
        orientation: isLandscape ? "landscape" : "portrait",
        unit: "pt",
        format: [pdfWidthPt, pdfHeightPt]
      });
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidthPt, pdfHeightPt);
      pdf.save("Calligraphy Layout Draft.pdf");
    }).catch(err => {
      console.error("html2canvas error:", err);
    }).finally(() => {
      isExportingPassagePDF = false;
      downloadBtn.disabled = false;
    });
  }
});
